import { Injectable, inject } from '@angular/core';
import { DateConverterService } from '@shared/consumption';
import type { RoomsConsumption, RoomsConsumptionFromApi } from '../models';

@Injectable({
  providedIn: 'root',
})
export class RoomConsumptionsConversionService {
  private readonly dateConverter = inject(DateConverterService);

  public convertDateStringToDateObject(data: RoomsConsumptionFromApi): RoomsConsumption {
    const result: RoomsConsumption = {
      ...data,
      roomsWithValues: [],
    };

    data.roomsWithValues.forEach((room) => {
      if (!room.realRoom) {
        room.label = 'ROOMS_CONSUMPTION_UNASSIGNED';
      }

      const values = Object.keys(room.values).map((key) => ({
        date: this.dateConverter.convertDateStringToDateObject(key),
        value: room.values[key],
      }));

      result.roomsWithValues.push({
        ...room,
        values,
      });
    });

    return result;
  }
}
